<div class="external-share-holding-container">
    <div class="external-share-holding-container-row">
        <div class="external-share-holding-container-element">
            <div class="external-share-holding-element-label">External share price <span id="externalSharesToolTipIcon"
                                                                                         class="infoIcon" calltoaction
                                                                                         [calltoactionTemplate]="externalShareHoldingToolTipTemplateRef"></span>
            </div>
            <div class="external-share-holding-element-input">
                <span class="external-share-dollar-symbol">$</span>
                <span class="external-share-holding-textbox">

            <input type="text" pInputText [value]="externalSharePrice" [required]="true"
                   autocomplete="off"
                   autocorrect="off"
                   autocapitalize="off"
                   spellcheck="false"
                   [formControl]="externalSharePriceInputControl"
                   tooltip
                   [tooltipTitle]="tooltipMessage"
                   [tooltipPosition]="'right'"
                   tooltipClass="error"
                   [tooltipHorizontalOffset]="8"
                   (input)="onInput()"
                   (change)="onChange()"
                   (focusout)="onFocusOut()"
                   #externalShareHoldingPriceInputField>
            </span>
            </div>
        </div>

        <ng-template #externalShareHoldingToolTipTemplateRef>
            <div>
                You must enter the share price for any securities not in the Charles Schwab & Company, Inc. ("Schwab")
                security master. If a share price is <em>not</em> entered for an externally held security,
                iRebal will assume a price of $1. For any securities that are in the Schwab
                database, iRebal will calculate the position's value based on the shares you have listed here
                and the current market price.
            </div>
        </ng-template>
    </div>
</div>

